// Re-export base types from shared package
export type {
  Bill,
  BillStatus,
  BillUpdate,
  BillUpdateType,
  BillCommunicationLog,
  CommType,
  CommDirection,
  CaseStage,
  CaseWaitingOn,
  CaseOutcome,
  ResolutionPath,
  CustomerRequest,
} from '@mediloop/shared';

import type { BillStatus } from '@mediloop/shared';

// App-specific UI constant — maps statuses to display labels and CSS classes
export const STATUS_CONFIG: Record<BillStatus, { label: string; className: string }> = {
  submitted:        { label: 'Case filed',              className: 'status-submitted' },
  in_review:        { label: 'Reviewing your bill',     className: 'status-in-review' },
  negotiating:      { label: 'Negotiating with the provider',  className: 'status-negotiating' },
  negotiating_more: { label: 'Partial win, pushing for more', className: 'status-negotiating-more' },
  financial_assistance: { label: 'Financial assistance applied for', className: 'status-financial-assistance' },
  completed:        { label: 'Case closed',             className: 'status-completed' },
  no_savings:       { label: 'Closed, no savings found',        className: 'status-no-savings' },
  info_needed:      { label: 'We need something from you',            className: 'status-info-needed' },
  no_response:      { label: 'Waiting on you',          className: 'status-no-response' },
  canceled:         { label: 'Case withdrawn',          className: 'status-canceled' },
};
